import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53850a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "Modal_Content"
}
const _hoisted_2 = { class: "Modal_Header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Modal_Header_Title" }, "備考入力", -1))
const _hoisted_4 = { class: "Modal_Main" }
const _hoisted_5 = { class: "Modal_Table" }
const _hoisted_6 = { class: "Modal_Table_Yoko" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌CD", -1))
const _hoisted_8 = { class: "Modal_Table_Yoko" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌名", -1))
const _hoisted_10 = { class: "Modal_Table_Yoko" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "Modal_Table_InputBikou" }, [
  /*#__PURE__*/_createTextVNode(" 備考"),
  /*#__PURE__*/_createElementVNode("br", { class: "Modal_Index" }),
  /*#__PURE__*/_createTextVNode("入力 ")
], -1))
const _hoisted_12 = { class: "Modal_Table_InputBikou" }
const _hoisted_13 = {
  key: 0,
  class: "error_text"
}
const _hoisted_14 = { class: "Modal_Table_Yoko" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("表示"),
  /*#__PURE__*/_createElementVNode("br", { class: "Modal_Index" }),
  /*#__PURE__*/_createTextVNode("期限")
], -1))
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "Modal_Table_MukigenCheck" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mukigenCheck" }, "無期限", -1))
const _hoisted_19 = {
  key: 0,
  class: "error_text"
}
const _hoisted_20 = { class: "Modal_Container_Btn" }
const _hoisted_21 = {
  key: 1,
  class: "Btn_Disabled",
  style: {"margin-left":"5px"}
}

import BtnGreen from "../../components/atoms/button/BtnGreen.vue";
import { ref } from "vue";
import type { SelectedProductType } from "../../views/EditProductStatus.vue";
import axios from "axios";
import { useStore } from "vuex";
import ModalWarningMessage from "./ModalWarningMessage.vue";
import BtnWhite from "../atoms/button/BtnWhite.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalOrderSearchMemo',
  props: {
  isVisible: {
    required: true,
    type: Boolean,
    default: false,
  },
  selectedProduct: {
    required: true,
    type: Object as () => SelectedProductType,
  },
},
  emits: ["close", "updateBikou"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
// const emit = defineEmits<{
//   (event: "close"): void;
//   (event: "updateBikou", bikouVal: string, date_toVal: string): void;
// }>();

const store = useStore();

// propsの型定義 調査中...↓
let bikou = ref(
  props.selectedProduct.itemRemarks ? props.selectedProduct.itemRemarks : ""
);
let date_to = ref("");
let isMukigenChecked = ref(false);

// 初期表示設定
const showDeleteBtn = ref(false);
const initialDisplay = () => {
  // 表示期限
  if (
    props.selectedProduct.itemRemarks !== null &&
    props.selectedProduct.remarksDeadline === "9999-12-31"
  ) {
    isMukigenChecked.value = true;
  } else if (props.selectedProduct.remarksDeadline) {
    date_to.value = props.selectedProduct.remarksDeadline;
  }

  // 削除ボタンの表示制御
  if (
    props.selectedProduct.itemRemarks !== null &&
    props.selectedProduct.remarksDeadline !== null
  ) {
    showDeleteBtn.value = true;
  }
};
initialDisplay();

// 削除ボタン関連-----------------------------------------------------
const modalName = ref("");
const warningMessage = ref(
  "設定されている備考情報を削除します。\n実行してもよろしいですか？"
);
const deleteBikouData = async () => {
  const sendData = {
    janCd: props.selectedProduct.janCd,
    itemRemarks: null,
    remarksDeadline: null,
    indefinite: false,
  };
  try {
    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/syosi/update_remarks`,
      sendData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    modalName.value = "";
    emit("updateBikou");
    emit("close");
  } catch (error) {
    alert("備考情報の削除に失敗しました");
    console.log(error);
  }
};

// 更新ボタン押下時の処理--------------------------------------------
let hasDateError = ref(false);
let hasBikouError = ref(false);

const updateBikou = async () => {
  // 表示期限バリデーション
  if (isMukigenChecked.value === false && date_to.value === "") {
    hasDateError.value = true;
  } else {
    hasDateError.value = false;
  }

  // 備考入力バリデーション
  if (bikou.value === null || bikou.value === "") {
    hasBikouError.value = true;
  } else {
    hasBikouError.value = false;
  }

  // エラーがない場合確定
  if (hasDateError.value === false && hasBikouError.value === false) {
    let dateTo: string | null = "";
    if (isMukigenChecked.value === true) {
      dateTo = null;
    } else {
      dateTo = date_to.value;
    }
    try {
      const sendData = {
        janCd: props.selectedProduct.janCd,
        itemRemarks: bikou.value,
        remarksDeadline: dateTo,
        indefinite: isMukigenChecked.value,
      };
      const res = await axios.patch(
        `${store.getters["getBaseUrl"]}/syosi/update_remarks`,
        sendData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      emit("updateBikou");
      emit("close");
    } catch (error) {
      console.log(error);
    }
  }
};

const closeModal = (): void => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (modalName.value === 'modalWarningMessage')
      ? (_openBlock(), _createBlock(ModalWarningMessage, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (modalName.value = '')),
          onExecute: deleteBikouData,
          message: warningMessage.value
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (__props.isVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "Modal",
          onClick: closeModal
        }))
      : _createCommentVNode("", true),
    (__props.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_font_awesome_icon, {
              onClick: closeModal,
              class: "Modal_Header_Close",
              icon: "xmark"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("tr", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("td", null, _toDisplayString(__props.selectedProduct.syosiCd), 1)
              ]),
              _createElementVNode("tr", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("td", null, _toDisplayString(__props.selectedProduct.title), 1)
              ]),
              _createElementVNode("tr", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "Modal_Table_InputText",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(bikou) ? (bikou).value = $event : bikou = $event))
                  }, null, 512), [
                    [_vModelText, _unref(bikou)]
                  ]),
                  (_unref(hasBikouError))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 備考内容を入力してください "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "Modal_Table_InputDate",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(date_to) ? (date_to).value = $event : date_to = $event)),
                    disabled: _unref(isMukigenChecked)
                  }, null, 8, _hoisted_16), [
                    [_vModelText, _unref(date_to)]
                  ]),
                  _createElementVNode("span", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "mukigenCheck",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(isMukigenChecked) ? (isMukigenChecked).value = $event : isMukigenChecked = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _unref(isMukigenChecked)]
                    ])
                  ]),
                  (_unref(hasDateError))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 表示期限を入力してください "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(BtnGreen, {
              onClick: updateBikou,
              style: {"margin-right":"5px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("確定")
              ]),
              _: 1
            }),
            (showDeleteBtn.value)
              ? (_openBlock(), _createBlock(BtnWhite, {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (modalName.value = 'modalWarningMessage')),
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("設定削除")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("button", _hoisted_21, " 設定削除 "))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})